import compiledApi from "./compiledApi.json";

export const api = compiledApi;

export default {
	api,
};
